import React, { useContext, useEffect, useState } from "react";
//import {LayerSwitcher} from "./ol-layerswitcher.js";
//import LayerSwitcher from "./ol-layerswitcher";
//import LayerSwitcher from "'ol-layerswitcher';";
import LayerSwitcher from "ol-layerswitcher";
import { BaseLayerOptions, GroupLayerOptions } from "ol-layerswitcher";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import MapContext from "../Map/MapContext";
import Layer from "ol/layer/Layer";

const LayerHandler = () => {
    const { map } = useContext(MapContext);

    useEffect(() => {
        if (!map) return;

        let LayerHandler = new LayerSwitcher({
            reverse: true,
            //tipLabel: 'Légende',
            groupSelectStyle: 'children',
            //groupSelectStyle: 'group',
        });

    map.addControl(LayerHandler);
    //LayerHandler.showPanel();

    }, [map]);

    //return null;
    //LayerHandler.showPanel();
};

export default LayerHandler;